import { createDocument, deleteDocument, getDocuments, patchDocument } from '../services/documents';
import { TIMEZONE_GMT } from '../services/request';

const getTransactions = async ({
  chargeBoxPk,
  fromDate,
  toDate,
  userOcppTag,
  paymentStatus,
  searchInput,
  headerOrderList,
  page,
  size,
}): Promise<any> => {
  const data = await getDocuments(
    `transaction?chargeBoxPK=${chargeBoxPk}&fromDate=${fromDate}&toDate=${toDate}&ocppUserTag=${userOcppTag}&paymentStatus=${paymentStatus}&searchInput=${searchInput}${
      headerOrderList != null ? '&headerOrderList=' + headerOrderList : ''
    }&timeZone=${TIMEZONE_GMT}${page != null ? '&page=' + page : ''}${size != null ? '&size=' + size : ''}`,
  );
  return data;
};

const getTransactionData = async (transactionPk): Promise<any> => {
  const data = await getDocuments(`transaction/${transactionPk}`);
  return data;
};

const patchTransactionPaymentData = async (paymentForm, transactionPk): Promise<any> => {
  const data = await patchDocument(`transaction/${transactionPk}/pay`, paymentForm, 'payment');
  return data;
};

const patchConfirmPayments = async (confirmPaymentsForm): Promise<any> => {
  const data = await patchDocument('transaction/confirm_payments', confirmPaymentsForm, 'payment');
  return data;
};

const deleteIdleTransactionPayment = async (transactionPk): Promise<any> => {
  const data = await deleteDocument(`cancel-idle-payment/transaction/${transactionPk}`, 'payment');
  return data;
};

const stopCharging = async (transactionPk): Promise<any> => {
  const data = await createDocument({}, `transaction/${transactionPk}/stop`);
  return data;
};

const patchManualApprove = async (pk: number): Promise<any> => {
  const data = await patchDocument(`transaction/${pk}/manual-approve`, {}, 'payment');
  return data;
};

const postManualWalletCharge = async (
  pk: number,
  body: { cancelExistingPreAuth?: boolean },
): Promise<any> => {
  const data = await createDocument(body, `payment/transaction/${pk}/manual-wallet-charge`);
  return data;
};

const postManualCardCharge = async (pk: number): Promise<any> => {
  const data = await createDocument({}, `payment/transaction/${pk}/manual-card-charge`);
  return data;
};

export {
  getTransactions,
  getTransactionData,
  patchTransactionPaymentData,
  patchConfirmPayments,
  deleteIdleTransactionPayment,
  stopCharging,
  patchManualApprove,
  postManualWalletCharge,
  postManualCardCharge,
};
